import { render, staticRenderFns } from "./mypushtable.vue?vue&type=template&id=0f028afa&scoped=true&"
import script from "./mypushtable.vue?vue&type=script&lang=js&"
export * from "./mypushtable.vue?vue&type=script&lang=js&"
import style0 from "./mypushtable.vue?vue&type=style&index=0&id=0f028afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f028afa",
  null
  
)

export default component.exports